var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "scid-user",
      class: { "scid-user--hasUpdatedAvatar": _vm.updatedProfileImage !== "" },
    },
    [
      _c("div", {
        ref: "avatar",
        staticClass: "scid-user__avatar",
        style: _vm.avatarStyle,
      }),
      _c("p", {
        staticClass: "scid-user__username",
        domProps: { textContent: _vm._s(_vm.username) },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }